import React from "react"
import Form from "../common/Form"
import DynamicImage from "../common/DynamicImage"
import { HighlightText } from "../common/HighlightText"

const ContactForm = ({ data }) => {
  return (
    <>
      <section className="contact-area ptb-70">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-8 col-md-12">
              <div className="section-title text-center mb-3">
               {data.title && <h2><HighlightText content={data.title} /></h2>}
                {data?.description?.map((block, index) => {
                  switch (block.type) {
                    case "paragraph":
                      return (
                        <p key={index}>
                          {block.children.map(c => c.text).join("")}
                        </p>
                      );

                    case "heading":
                      const Tag = `h${block.level}`;
                      return (
                        <Tag key={index} className="mt-4 mb-3">
                          <HighlightText content={block.children.map(c => c.text).join("")} />
                        </Tag>
                      );

                    case "list":
                      return (
                        <ul key={index} className="list-unstyled">
                          {block.children.map((item, i) => (
                            <li key={i} className="features-text">
                              <h4>
                                <i className="flaticon-tick"></i>{" "}
                                {item.children.map(c => c.text).join("")}
                              </h4>
                            </li>
                          ))}
                        </ul>
                      );

                    default:
                      return null;
                  }
                })}
              </div>

            </div>
            {data?.image?.url && (
              <div className="col-lg-6 col-md-12">
                <div className="contact-image">
                  <DynamicImage image={data.image} />
                </div>
              </div>
            )}
            <div className="col-lg-6 col-md-12">
              <div className="contact-form">
                <Form section="bottom" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ContactForm
